export const START_LOAD = "team/START_LOAD";
export const FINISH_LOAD = "team/FINISH_LOAD";

const START_PAYING_FOR_TEAM_SLOTS = "START_PAYING_FOR_TEAM_SLOTS";
const FINISH_PAYING_FOR_TEAM_SLOTS = "FINISH_PAYING_FOR_TEAM_SLOTS";

const initialState = {
  loading: false,
  team: null,

  payingForSlots: false,
};
export default function reducer(state = initialState, action = {}) {
  
  switch (action.type) {
    case START_LOAD:
      return { ...state, loading: true };
    case FINISH_LOAD:
      return { ...state, loading: false, team: action.payload };
    // case UPDATE_SLOTS: {
    //     let team = state.team;
    //     team = {...team, crews: action.payload}
    //     return {...state, team: team}
    // }

    case START_PAYING_FOR_TEAM_SLOTS:
      return {
        ...state,
        payingForSlots: true,
      };

    case FINISH_PAYING_FOR_TEAM_SLOTS:
      return {
        ...state,
        payingForSlots: false,
        team: action.payload,
      };
    default:
      return state;
  }
}
